const validate = data => {
  // must have atleast 1 action step status
  if (data.action_status.length < 1) {
    // error
    return {action_status: ['Please select atleast 1 status.']}
  }

  // action step must have a field
  const _action_steps = data.action_steps.filter(s => !s.is_deleted)
  const _action_step_fields = _action_steps.filter(
    s => !s.return_field_data || !s.return_field_data.id
  )

  if (_action_step_fields.length > 0) {
    // error
    return {action_steps: ['Please select reservation field for the action.']}
  } else if (_action_steps.length < 1) {
    // error
    return {action_steps: ['Please select atleast 1 action.']}
  }

  return null
}

export default validate
